var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseGreen = function SvgCloseGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "6px",
    viewBox: "0 0 6 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icons / Navigation / Check")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filters-&-Categories",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Experince-Filters-XS",
    transform: "translate(-110.000000, -445.000000)",
    fill: "#00983F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "applied-filters",
    transform: "translate(16.000000, 432.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(91.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-185-Copy",
    transform: "translate(6.000000, 6.000000) rotate(-45.000000) translate(-6.000000, -6.000000) translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 C4.27614237,1.69088438e-17 4.5,0.223857625 4.5,0.5 L4.5,3.5 L7.5,3.5 C7.77614237,3.5 8,3.72385763 8,4 C8,4.27614237 7.77614237,4.5 7.5,4.5 L4.499,4.5 L4.5,7.5 C4.5,7.77614237 4.27614237,8 4,8 C3.72385763,8 3.5,7.77614237 3.5,7.5 L3.499,4.5 L0.5,4.5 C0.223857625,4.5 2.84555271e-14,4.27614237 2.84217094e-14,4 C2.83878917e-14,3.72385763 0.223857625,3.5 0.5,3.5 L3.5,3.5 L3.5,0.5 C3.5,0.223857625 3.72385763,-1.69088438e-17 4,0 Z",
    id: "Combined-Shape"
  }))))))));
};
export default SvgCloseGreen;